import React from "react";

const Newsletter = () => {
  return (
    <div className="p-10 flex lg:flex-row md:flex-row flex-col justify-between gap-2 items-center bg-[#F9FAFB] ">
      <div>
        <h3 className="text-xl font-semibold text-black mb-2">
          Join our newsletter
        </h3>
        <p className="text-accent ">
          Get updated with all the awesome things !
        </p>
      </div>
      <div className="flex gap-2 items-center flex-wrap">
        <input
          type="text"
          name=""
          id=""
          placeholder="Enter your email"
          className=" border border-gray-400 focus:outline-primary rounded-lg py-2 px-3 lg:w-2/3 md:w-[2/3] w-full"
        />
        <button className="rounded-lg py-2 px-3 bg-primary text-white">
          Subscribe
        </button>
      </div>
    </div>
  );
};

export default Newsletter;
